import * as Sentry from "@sentry/vue";
import AlertRequestQuery from "~/entities/AlertRequestQuery";
import ValidationModule from "~/entities/ValidationModule";

export default class ValidationAuth extends ValidationModule {
  public registerAlerts = {
    selector: {},
    needle: [""],
  };
  public loginAlerts = {
    selector: {},
    needle: [""],
  };
  public guestAlerts = {
    selector: {},
    needle: [""],
  };
  public forgetPasswordAlerts = {
    selector: {},
    needle: [""],
  };
  public resetPasswordAlerts = {
    selector: {},
    needle: [""],
  };
  public addressAlerts = {
    selector: {
      companyName: "AlertCompanyNameTooLong",
    },
    needle: [""],
  };

  public constructor() {
    super("");
    this.resetValidations();
    this.alertNames = [
      "AlertCompanyNameTooLong", //To prevent delays and problems with your shipment, your company name will be limited to 35 characters in the shipment label.
    ];
    this.alertTypes = {
      //fill
      register: this.registerAlerts,
      login: this.loginAlerts,
      guest: this.guestAlerts,
      forgetPassword: this.forgetPasswordAlerts,
      resetPassword: this.resetPasswordAlerts,
      address: this.addressAlerts,
    };
  }

  public async Validate(scope: string = "") {
    this.resetValidations();
    let errors = 0;
    switch (scope) {
      case "register":
        if (!this.validatePhoneNumber(this.component?.$refs.InputPhone)) {
          errors++;
          this.validationErrors.push("register-phone");
        }
        if (!this.validatePassword(this.component?.password)) {
          errors++;
          this.validationErrors.push("register-password");
        }
        if (
          !this.validateConfirmPassword(
            this.component?.password,
            this.component?.confirmPassword
          )
        ) {
          errors++;
          this.validationErrors.push("register-confirm-password");
        }
        if (
          !this.component.$refs.registerEmail &&
          this.component.$refs.registerEmail.checkValidity()
        ) {
          errors++;
          this.validationErrors.push("register-confirm-password");
        }
        break;
      case "login":
        break;
      case "guest":
        break;
      case "forgetPassword":
        break;
      case "resetPassword":
        break;
      default:
        Sentry.addBreadcrumb({
          category: "ValidationAuth.Validate",
          level: "warning",
          message: "Validate called without valid scope",
          data: { scope }
        });
    }
    if (errors == 0) {
      this.validated = true;
      this.validationMade = true;
    } else {
      this.validated = false;
      this.validationMade = true;
    }
    return !errors;
  }
  public resetValidations() {
    this.validated = false;
    this.validationMade = false;
    this.validationErrors = [];
    this.component?.clearActiveNotices();
  }
  public requestAlert(data: any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data, "asObject"));
  }
  public addNotice(data: any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }
  public removeNotice(data: any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }
  protected getFilteredAlertKey(
    data: any,
    returnType: string = "asString"
  ): any {
    let keyGetter = new AlertRequestQuery();
    if (data.hasOwnProperty("type")) {
      switch (data.type) {
        case "register":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
        case "login":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
        case "guest":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
        case "forgetPassword":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
        case "resetPassword":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
        case "address":
          keyGetter.name = this.alertTypes[data.type].selector[data.name];
          keyGetter.typeSelector = data.name;
          break;
      }
    } else {
      //fill
    }
    let filteredData = keyGetter.getKey(
      this.alertNames,
      this.alertTypes[data.type]
    );
    if (returnType == "asString") {
      return filteredData.name;
    } else {
      return filteredData;
    }
  }

  public validatePhoneNumber(phoneInputRef: any) {
    if (phoneInputRef && phoneInputRef?.phoneObject)
      // Rules defined in the component
      return phoneInputRef.phoneObject.valid;
    return false;
  }
  public validatePassword(password: string) {
    var re =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?]).{6,}$/;
    if (password) {
      return re.test(password);
    }
    return false;
  }
  public validateConfirmPassword(password: string, confirmPassword: string) {
    if (password === confirmPassword) {
      return true;
    }
    return false;
  }
  public validateEmail(email: string) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
}
